<template>
  <HeaderBlock />
  <div class="section_full_header">
    <div class="day_night_container">
      <div class="day_night_block">
        <div class="day_night_text_block">
          <p class="delivery_name">доставка<br />и оплата</p>
        </div>
        <div class="day_night_img_block">
          <div class="day_night_img">
            <img
              class="day_night_img1"
              src="@/assets/img/day_night1.png"
              alt=""
            />
            <p class="day_night_text_img color_white">
              Более высокая<br />усвояемость<br />никотина
            </p>
          </div>
          <div class="day_night_img">
            <img
              class="day_night_img1"
              src="@/assets/img/day_night2.png"
              alt=""
            />
            <p class="day_night_text_img color_white">
              Отличное<br />насыщение
            </p>
          </div>
          <div class="day_night_img">
            <img
              class="day_night_img1"
              src="@/assets/img/day_night3.png"
              alt=""
            />
            <p class="day_night_text_img color_white">
              Инновационный<br />подход
            </p>
          </div>
        </div>
      </div>
    </div>

    <SocialMediaV2 />
  </div>
  <div class="delivery_pay_container">
    <div class="delivery_pay_block delivery_pay_block_pos">
      <p class="delivery_pay_name">доставка</p>
      <p class="delivery_pay_text">
        Отправка любой транспортной компанией за счет клиента.
      </p>
    </div>
    <div class="delivery_pay_block delivery_pay_block_pos2">
      <p class="delivery_pay_name">оплата</p>
      <div class="delivery_pay_text_block">
        <p class="delivery_pay_text">Вы можете оплатить заказ:</p>
        <div class="delivery_pay_text_end">
          <p class="delivery_pay_text delivery_pay_text_mobile1">
            1. Банковской картой Visa, Mastercard <br />
            &nbsp;&nbsp;&nbsp;или МИР при оформлении заказа
          </p>
          <p class="delivery_pay_text delivery_pay_text_mobile">
            1. Банковской картой Visa, Mastercard или МИР при оформлении заказа
          </p>
          <p class="delivery_pay_text">2. Наличными (только при самовывозе)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="black_hole_between"></div>
  <MakeorderBlock />
  <FooterBlock />
</template>

<script>
import HeaderBlock from "./stabl/HeaderBlock.vue";
import MakeorderBlock from "./stabl/MakeorderBlock.vue";
import FooterBlock from "./stabl/FooterBlock.vue";
import SocialMediaV2 from "@/components/UI/SocialMediaV2.vue";
export default {
  components: {
    HeaderBlock,
    MakeorderBlock,
    FooterBlock,
    SocialMediaV2,
  },
};
</script>
